module.exports = __webpack_public_path__ + "static/media/sam-cu-tam-mat-ong.3de13823.jpg";